/* ══ PRAESENS — LIFTFACE JS ══ */

var LF_EN = (document.documentElement.lang || 'fr').toLowerCase().indexOf('en') === 0;
var LF_T = LF_EN ? {
  cart: 'Cart', emptyCart: 'YOUR CART<br>IS EMPTY',
  securePayments: 'Secure payments', secureSub: 'Card, PayPal or Klarna',
  reserved1: 'Your cart is reserved for ',
  freeShipping: '<strong>Free shipping</strong> included',
  guarantee: '30-day guarantee', klarna: 'Klarna 3x', secure: 'Secure', days: '6-10 days',
  shippingLabel: 'Shipping', free: 'Free', checkout: 'CHECKOUT &mdash; ',
  adding: 'Adding...', added: '\u2713 Added!', redirecting: 'Redirecting...', redirectKlarna: 'Redirecting to Klarna...',
  showLess: 'Show less', showMore: 'Show more', addBtn: 'ADD',
  addError: 'Unable to add to cart: '
} : {
  cart: 'Panier', emptyCart: 'VOTRE PANIER<br>EST VIDE',
  securePayments: 'Paiements s\u00e9curis\u00e9s', secureSub: 'Par carte bancaire, PayPal ou Klarna',
  reserved1: 'Votre panier est r\u00e9serv\u00e9 pendant ',
  freeShipping: '<strong>Livraison gratuite</strong> incluse',
  guarantee: 'Garantie 30j', klarna: 'Klarna 3x', secure: 'S\u00e9curis\u00e9', days: '6j ouvr\u00e9s',
  shippingLabel: 'Frais de livraison', free: 'Gratuit', checkout: 'PAIEMENT &mdash; ',
  adding: 'Ajout en cours...', added: '\u2713 Ajout\u00e9 !', redirecting: 'Redirection...', redirectKlarna: 'Redirection vers Klarna...',
  showLess: 'Voir moins', showMore: 'Afficher plus', addBtn: 'AJOUTER',
  addError: 'Impossible d\'ajouter au panier : '
};
function lfMoney(cents, currency){
  var cur = currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  try {
    return new Intl.NumberFormat(LF_EN ? 'en-AU' : 'fr-FR', { style: 'currency', currency: cur }).format(cents / 100);
  } catch(e) {
    return (cents / 100).toFixed(2) + ' ' + cur;
  }
}
/* Ajout au panier avec VRAIE gestion d'erreur : renvoie une promesse {ok, data} et affiche l'erreur Shopify si refus */
function lfAddToCart(payload){
  var opts = payload instanceof FormData
    ? { method: 'POST', body: payload }
    : { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(payload) };
  return fetch('/cart/add.js', opts).then(function(r){
    return r.json().catch(function(){ return {}; }).then(function(data){
      var failed = !r.ok || (data && data.status && data.status >= 400);
      if(failed){
        var msg = (data && (data.description || data.message)) || ('HTTP ' + r.status);
        console.error('[DERMALIS] /cart/add.js FAILED', r.status, data);
        alert(LF_T.addError + msg);
        return { ok: false, data: data };
      }
      return { ok: true, data: data };
    });
  }).catch(function(err){
    console.error('[DERMALIS] /cart/add.js NETWORK ERROR', err);
    alert(LF_T.addError + (err && err.message ? err.message : 'network'));
    return { ok: false, data: null };
  });
}

/* Announcement bar */
(function(){
  var msgs = document.querySelectorAll('.announcement-msg');
  if(msgs.length === 0) return;
  var current = 0;
  msgs[0].classList.add('active');
  if(msgs.length > 1){
    setInterval(function(){
      msgs[current].classList.remove('active');
      current = (current + 1) % msgs.length;
      msgs[current].classList.add('active');
    }, 3000);
  }
})();

/* Mobile hero swipe carousel */
(function(){
  var track = document.getElementById('hero-swipe-track');
  var dotsWrap = document.getElementById('hero-dots');
  if(!track || !dotsWrap) return;
  var slides = track.querySelectorAll('.hero-slide');
  if(slides.length === 0) return;
  slides.forEach(function(_, i){
    var dot = document.createElement('button');
    dot.className = 'hero-dot' + (i === 0 ? ' active' : '');
    dot.setAttribute('aria-label', 'Photo ' + (i + 1));
    dot.addEventListener('click', function(){
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    });
    dotsWrap.appendChild(dot);
  });
  var dots = dotsWrap.querySelectorAll('.hero-dot');
  var mobileThumbs = document.querySelectorAll('.hero-mobile-thumb');
  mobileThumbs.forEach(function(thumb){
    thumb.addEventListener('click', function(){
      var slideIdx = parseInt(this.getAttribute('data-slide'));
      if(slides[slideIdx]){
        track.scrollTo({ left: slides[slideIdx].offsetLeft, behavior: 'smooth' });
      }
    });
  });
  var scrollTimer;
  track.addEventListener('scroll', function(){
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function(){
      var scrollLeft = track.scrollLeft;
      var trackW = track.offsetWidth;
      var idx = Math.round(scrollLeft / trackW);
      dots.forEach(function(d, i){ d.classList.toggle('active', i === idx); });
      mobileThumbs.forEach(function(t, i){ t.classList.toggle('active', i === idx); });
    }, 50);
  });
})();

/* Sticky bar */
(function(){
  var sbar = document.getElementById('sticky-bar');
  var hero = document.getElementById('hero');
  if(sbar && hero){
    new IntersectionObserver(function(e){sbar.classList.toggle('show',!e[0].isIntersecting);},{threshold:.1}).observe(hero);
  }
})();

/* Mobile menu */
(function(){
  var hamburger = document.getElementById('nav-hamburger');
  var menu = document.getElementById('mobile-menu');
  var overlay = document.getElementById('mobile-menu-overlay');
  var closeBtn = document.getElementById('mobile-menu-close');
  if(!hamburger || !menu) return;
  function openMenu(){ menu.classList.add('open'); overlay.classList.add('open'); document.body.style.overflow='hidden'; }
  function closeMenu(){ menu.classList.remove('open'); overlay.classList.remove('open'); document.body.style.overflow=''; }
  hamburger.addEventListener('click', openMenu);
  if(closeBtn) closeBtn.addEventListener('click', closeMenu);
  if(overlay) overlay.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeMenu(); });
  menu.querySelectorAll('.mobile-menu-links a').forEach(function(a){ a.addEventListener('click', closeMenu); });
})();

/* Hero trust rotating text */
(function(){
  var msgs = document.querySelectorAll('.hero-trust-msg');
  var dots = document.querySelectorAll('.htd');
  if(msgs.length === 0) return;
  var idx = 0;
  setInterval(function(){
    msgs[idx].classList.remove('active');
    if(dots[idx]) dots[idx].classList.remove('active');
    idx = (idx + 1) % msgs.length;
    msgs[idx].classList.add('active');
    if(dots[idx]) dots[idx].classList.add('active');
  }, 2000);
})();

/* Reveal */
(function(){
  var revealSel = '.rv,.rv-left,.rv-right,.rv-scale,.rv-type';
  document.querySelectorAll(revealSel).forEach(function(el){
    new IntersectionObserver(function(e){if(e[0].isIntersecting){e[0].target.classList.add('v');e[0].target.dispatchEvent(new Event('revealed'));}},{threshold:.1}).observe(el);
  });
  setTimeout(function(){
    document.querySelectorAll(revealSel).forEach(function(el){
      if(!el.classList.contains('v')){ el.classList.add('v'); el.dispatchEvent(new Event('revealed')); }
    });
  }, 600);
})();

/* Counter animation */
(function(){
  document.querySelectorAll('.count-up').forEach(function(el){
    var counted = false;
    new IntersectionObserver(function(entries){
      if(entries[0].isIntersecting && !counted){
        counted = true;
        var raw = el.getAttribute('data-count') || '0';
        var target = parseFloat(raw.replace(/[^0-9.]/g,''));
        var suffix = el.textContent.replace(/[0-9.,]/g,'').trim() || raw.replace(/[0-9.]/g,'');
        var isDecimal = raw.indexOf('.') !== -1;
        var duration = 1800;
        var start = performance.now();
        function step(now){
          var progress = Math.min((now - start) / duration, 1);
          var ease = 1 - Math.pow(1 - progress, 3);
          var current = Math.round(ease * target);
          if(isDecimal) current = (ease * target).toFixed(1);
          el.textContent = current.toLocaleString(LF_EN ? 'en-AU' : 'fr-FR') + suffix;
          if(progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
    },{threshold:.2}).observe(el);
  });
})();

/* Gallery thumbs */
(function(){
  var mainImg = document.getElementById('hero-main-photo');
  if(!mainImg) return;
  document.querySelectorAll('.hero-thumb').forEach(function(t){
    t.addEventListener('click',function(){
      document.querySelectorAll('.hero-thumb').forEach(function(x){x.classList.remove('active');});
      this.classList.add('active');
      var full = this.getAttribute('data-full');
      if(full && mainImg.tagName === 'IMG') mainImg.src = full;
    });
  });
})();

/* Toggle reviews */
(function(){
  var btn = document.getElementById('rev-toggle');
  var extra = document.getElementById('reviews-extra');
  if(!btn || !extra) return;
  var open = false;
  btn.addEventListener('click',function(){
    open = !open;
    extra.classList.toggle('show', open);
    btn.textContent = open ? LF_T.showLess : LF_T.showMore;
    if(open){
      extra.querySelectorAll('.rv').forEach(function(el){
        new IntersectionObserver(function(e){if(e[0].isIntersecting)e[0].target.classList.add('v');},{threshold:.1}).observe(el);
      });
    }
  });
})();

/* Tabs: Avis / Questions */
(function(){
  var tabs = document.querySelectorAll('.reviews-tab');
  if(tabs.length < 2) return;
  var reviewsList = document.getElementById('reviews-list');
  var reviewsExtra = document.getElementById('reviews-extra');
  var reviewsMore = document.querySelector('.reviews-more');
  var reviewsActions = document.querySelector('.reviews-actions');
  var questionsPanel = document.getElementById('questions-panel');
  tabs.forEach(function(tab, idx){
    tab.addEventListener('click', function(){
      tabs.forEach(function(t){ t.classList.remove('active'); });
      this.classList.add('active');
      if(idx === 0){
        if(reviewsList) reviewsList.style.display = '';
        if(reviewsExtra) reviewsExtra.style.display = '';
        if(reviewsMore) reviewsMore.style.display = '';
        if(reviewsActions) reviewsActions.style.display = '';
        if(questionsPanel) questionsPanel.style.display = 'none';
      } else {
        if(reviewsList) reviewsList.style.display = 'none';
        if(reviewsExtra) reviewsExtra.style.display = 'none';
        if(reviewsMore) reviewsMore.style.display = 'none';
        if(reviewsActions) reviewsActions.style.display = 'none';
        if(questionsPanel){ questionsPanel.style.display = 'block';
          questionsPanel.querySelectorAll('.rv').forEach(function(el){
            new IntersectionObserver(function(e){if(e[0].isIntersecting)e[0].target.classList.add('v');},{threshold:.1}).observe(el);
          });
        }
      }
    });
  });
})();

/* FAQ + Pourquoi accordions */
document.querySelectorAll('.faq-q,.pq-q').forEach(function(q){
  q.addEventListener('click',function(){
    var item = this.parentElement;
    var siblings = item.parentElement.querySelectorAll('.faq-item,.pq-item');
    var wasOpen = item.classList.contains('open');
    siblings.forEach(function(x){x.classList.remove('open');});
    if(!wasOpen) item.classList.add('open');
  });
});

/* ══ CART DRAWER — devise dynamique + bilingue + erreurs visibles ══ */
(function(){

  var drawer = document.createElement('div');
  drawer.id = 'cart-drawer';
  drawer.innerHTML = '<div class="cart-drawer-overlay"></div><div class="cart-drawer-panel">' +
    '<div class="cart-drawer-head">' +
      '<span class="cart-drawer-title">' + LF_T.cart + ' <span class="cart-drawer-count" id="cart-drawer-count"></span></span>' +
      '<button class="cart-drawer-close"><svg viewBox="0 0 24 24" style="width:18px;height:18px;stroke:currentColor;fill:none;stroke-width:2;"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>' +
    '</div>' +
    '<div class="cart-drawer-timer" id="cart-drawer-timer" style="display:none;"></div>' +
    '<div class="cart-drawer-secure" id="cart-drawer-secure" style="display:none;">' +
      '<strong>' + LF_T.securePayments + '</strong>' +
      '<span>' + LF_T.secureSub + '</span>' +
    '</div>' +
    '<div class="cart-drawer-body" id="cart-drawer-body">' +
      '<div class="cart-empty">' +
        '<p class="cart-empty-text">' + LF_T.emptyCart + '</p>' +
      '</div>' +
    '</div>' +
    '<div class="cart-drawer-foot" id="cart-drawer-foot"></div>' +
  '</div>';
  document.body.appendChild(drawer);

  var overlay = drawer.querySelector('.cart-drawer-overlay');
  var closeBtn = drawer.querySelector('.cart-drawer-close');

  function openDrawer(){ drawer.classList.add('open'); document.body.style.overflow='hidden'; }
  function closeDrawer(){ drawer.classList.remove('open'); document.body.style.overflow=''; }
  overlay.addEventListener('click', closeDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeDrawer(); });

  var cartIcon = document.querySelector('.nav-cart-icon');
  if(cartIcon){
    cartIcon.style.cursor = 'pointer';
    cartIcon.addEventListener('click', function(){ refreshCart(); openDrawer(); });
  }

  var timerInterval = null;
  var timerSeconds = 30 * 60;
  function renderTimer(timerEl){
    var m = Math.floor(timerSeconds / 60);
    var s = timerSeconds % 60;
    timerEl.innerHTML = '<span>' + LF_T.reserved1 + '<strong>' + m + ':' + (s < 10 ? '0' : '') + s + '</strong></span>';
  }
  function startTimer(){
    var timerEl = document.getElementById('cart-drawer-timer');
    if(!timerEl) return;
    timerEl.style.display = 'flex';
    timerSeconds = 30 * 60;
    if(timerInterval) clearInterval(timerInterval);
    timerInterval = setInterval(function(){
      timerSeconds--;
      if(timerSeconds <= 0){ clearInterval(timerInterval); timerSeconds = 0; }
      renderTimer(timerEl);
    }, 1000);
    renderTimer(timerEl);
  }

  function refreshCart(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      var body = document.getElementById('cart-drawer-body');
      var foot = document.getElementById('cart-drawer-foot');
      var countEl = document.getElementById('cart-drawer-count');
      var timerEl = document.getElementById('cart-drawer-timer');
      var secureEl = document.getElementById('cart-drawer-secure');
      var currency = cart.currency;

      if(countEl) countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';

      if(cart.item_count === 0){
        body.innerHTML = '<div class="cart-empty"><p class="cart-empty-text">' + LF_T.emptyCart + '</p></div>';
        foot.innerHTML = '';
        if(timerEl) timerEl.style.display = 'none';
        if(secureEl) secureEl.style.display = 'none';
        if(timerInterval){ clearInterval(timerInterval); timerInterval = null; }
        return;
      }

      if(secureEl) secureEl.style.display = 'flex';
      if(!timerInterval) startTimer();

      var html = '';
      cart.items.forEach(function(item, i){
        var img = item.image ? '<img src="'+item.image.replace(/(\.[^.]+)$/,'_200x$1')+'" alt="'+item.title+'">' : '';
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-item-variant">'+item.variant_title+'</div>' : '';
        html += '<div class="cart-item" style="animation-delay:'+( i * 0.06 )+'s">' +
          '<div class="cart-item-img">'+img+'</div>' +
          '<div class="cart-item-info">' +
            '<div class="cart-item-name">'+item.title+'</div>'+variant+
            '<div class="cart-item-price">'+lfMoney(item.final_line_price, currency)+'</div>' +
            '<div class="cart-item-qty">' +
              '<div class="cart-qty-select">' +
                '<span>'+item.quantity+'</span>' +
                '<svg viewBox="0 0 24 24" style="width:12px;height:12px;stroke:currentColor;fill:none;stroke-width:2;"><polyline points="6 9 12 15 18 9"/></svg>' +
                '<select class="cart-qty-dropdown" data-key="'+item.key+'">';
        for(var q=1;q<=10;q++){
          html += '<option value="'+q+'"'+(q===item.quantity?' selected':'')+'>'+q+'</option>';
        }
        html += '</select></div></div></div>' +
          '<button class="cart-item-remove cart-qty-btn" data-key="'+item.key+'" data-qty="0">' +
            '<svg viewBox="0 0 24 24"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>' +
          '</button>' +
        '</div>';
      });
      body.innerHTML = html;

      var shippingHtml = '<div class="cart-shipping-bar"><div class="cart-shipping-fill" style="width:100%"></div><span class="cart-shipping-text"><svg viewBox="0 0 24 24" style="width:14px;height:14px;stroke:currentColor;fill:none;stroke-width:2;"><polyline points="20 6 9 17 4 12"/></svg> ' + LF_T.freeShipping + '</span></div>';

      var trustHtml = '<div class="cart-trust-row">' +
        '<div class="cart-trust-item"><svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>' + LF_T.guarantee + '</div>' +
        '<div class="cart-trust-item"><svg viewBox="0 0 24 24"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>' + LF_T.klarna + '</div>' +
        '<div class="cart-trust-item"><svg viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>' + LF_T.secure + '</div>' +
        '<div class="cart-trust-item"><svg viewBox="0 0 24 24"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg>' + LF_T.days + '</div>' +
      '</div>';

      foot.innerHTML = shippingHtml + trustHtml +
        '<div class="cart-total"><span>' + LF_T.shippingLabel + '</span><strong>' + LF_T.free + '</strong></div>' +
        '<a href="/checkout" class="cart-checkout-btn">' + LF_T.checkout + lfMoney(cart.total_price, currency) + '</a>';

      body.querySelectorAll('.cart-qty-dropdown').forEach(function(sel){
        sel.addEventListener('change', function(){
          var key = this.getAttribute('data-key');
          var qty = parseInt(this.value);
          fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(){refreshCart();updateBadge();});
        });
      });

      body.querySelectorAll('.cart-qty-btn').forEach(function(btn){
        btn.addEventListener('click',function(){
          var key = this.getAttribute('data-key');
          fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:0})}).then(function(){refreshCart();updateBadge();});
        });
      });
    });
  }

  function updateBadge(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      var badge = document.getElementById('cart-badge');
      if(!badge){
        badge = document.createElement('span');
        badge.id = 'cart-badge';
        badge.className = 'cart-badge';
        var badgeParent = document.querySelector('.nav-cart-icon');
        if(badgeParent) badgeParent.appendChild(badge);
      }
      if(cart.item_count > 0){ badge.textContent = cart.item_count; badge.style.display = 'flex'; }
      else { badge.style.display = 'none'; }
    });
  }
  updateBadge();

  function getProductHandle(){
    var heroEl = document.getElementById('hero');
    return heroEl ? (heroEl.getAttribute('data-product-handle') || '') : '';
  }

  var heroForm = document.getElementById('hero-add-form');

  if(heroForm){
    heroForm.addEventListener('submit',function(e){
      e.preventDefault();
      var btn = heroForm.querySelector('button[type="submit"]');
      var originalText = btn ? btn.textContent : '';
      if(btn){ btn.textContent = LF_T.adding; btn.style.opacity = '.6'; btn.disabled = true; }
      lfAddToCart(new FormData(heroForm))
      .then(function(res){
        if(!res.ok){
          if(btn){ btn.textContent = originalText; btn.style.opacity = '1'; btn.disabled = false; }
          return;
        }
        if(btn){ btn.textContent = LF_T.added; btn.style.opacity = '1'; }
        refreshCart();
        updateBadge();
        openDrawer();
        setTimeout(function(){ if(btn){ btn.textContent = originalText; btn.disabled = false; } }, 2000);
      });
    });
  }

  document.querySelectorAll('.add-to-cart-btn').forEach(function(btn){
    if(btn.closest('form')) return;
    btn.addEventListener('click',function(e){
      e.preventDefault();
      if(heroForm){
        heroForm.dispatchEvent(new Event('submit',{cancelable:true,bubbles:true}));
      } else {
        var handle = getProductHandle();
        if(!handle) return;
        var originalText = this.textContent;
        this.textContent = LF_T.adding; this.style.opacity = '.6'; this.disabled = true;
        var self = this;
        fetch('/products/' + handle + '.js')
        .then(function(r){ if(!r.ok){ throw new Error('Produit introuvable: ' + handle); } return r.json(); })
        .then(function(product){
          return lfAddToCart({id: product.variants[0].id, quantity: 1});
        })
        .then(function(res){
          if(!res || !res.ok){ self.textContent = originalText; self.style.opacity = '1'; self.disabled = false; return; }
          self.textContent = LF_T.added; self.style.opacity = '1';
          refreshCart(); updateBadge(); openDrawer();
          setTimeout(function(){ self.textContent = originalText; self.disabled = false; }, 2000);
        })
        .catch(function(err){ alert(LF_T.addError + err.message); self.textContent = originalText; self.style.opacity = '1'; self.disabled = false; });
      }
    });
  });

  function buyNowWithHandle(handle, btn){
    if(!handle) return;
    var originalText = btn ? btn.textContent : '';
    if(btn){ btn.textContent = LF_T.redirecting; btn.style.opacity = '.6'; btn.disabled = true; }
    fetch('/products/' + handle + '.js')
    .then(function(r){ if(!r.ok){ throw new Error('Produit introuvable: ' + handle); } return r.json(); })
    .then(function(product){
      var variantId = product.variants[0].id;
      return fetch('/cart/clear.js',{method:'POST'})
      .then(function(){
        return lfAddToCart({id: variantId, quantity: 1});
      });
    })
    .then(function(res){
      if(!res || !res.ok){
        if(btn){ btn.textContent = originalText; btn.style.opacity = '1'; btn.disabled = false; }
        return;
      }
      window.location.href = '/checkout';
    })
    .catch(function(err){
      alert(LF_T.addError + err.message);
      if(btn){ btn.textContent = originalText; btn.style.opacity = '1'; btn.disabled = false; }
    });
  }

  document.querySelectorAll('.buy-now-btn').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.preventDefault();
      e.stopPropagation();
      var handle = getProductHandle();
      if(handle){
        buyNowWithHandle(handle, this);
      } else if(heroForm){
        var self = this;
        var originalText = self.textContent;
        self.textContent = LF_T.redirecting; self.style.opacity = '.6'; self.disabled = true;
        var data = new FormData(heroForm);
        fetch('/cart/clear.js',{method:'POST'})
        .then(function(){ return lfAddToCart(data); })
        .then(function(res){
          if(!res || !res.ok){ self.textContent = originalText; self.style.opacity = '1'; self.disabled = false; return; }
          window.location.href = '/checkout';
        });
      }
    });
  });

  document.querySelectorAll('.buy-now-link[data-buy-handle]').forEach(function(link){
    link.addEventListener('click',function(e){
      e.preventDefault();
      var handle = this.getAttribute('data-buy-handle');
      if(handle) buyNowWithHandle(handle, this);
    });
  });

  document.querySelectorAll('.klarna-buy-btn').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      var self = this;
      var originalText = self.innerHTML;
      self.textContent = LF_T.redirectKlarna;
      self.style.opacity = '.6';
      self.disabled = true;
      function restore(){ self.innerHTML = originalText; self.style.opacity = '1'; self.disabled = false; }
      var handle = getProductHandle();
      if(handle){
        fetch('/products/' + handle + '.js')
        .then(function(r){ if(!r.ok){ throw new Error('Produit introuvable: ' + handle); } return r.json(); })
        .then(function(product){
          var variantId = product.variants[0].id;
          return fetch('/cart/clear.js',{method:'POST'})
          .then(function(){ return lfAddToCart({id: variantId, quantity: 1}); });
        })
        .then(function(res){
          if(!res || !res.ok){ restore(); return; }
          window.location.href = '/checkout?step=payment_method';
        })
        .catch(function(err){ alert(LF_T.addError + err.message); restore(); });
      } else if(heroForm){
        var data = new FormData(heroForm);
        fetch('/cart/clear.js',{method:'POST'})
        .then(function(){ return lfAddToCart(data); })
        .then(function(res){
          if(!res || !res.ok){ restore(); return; }
          window.location.href = '/checkout?step=payment_method';
        });
      }
    });
  });

})();

/* Review photo lightbox */
(function(){
  var lb = document.createElement('div');
  lb.className = 'review-lightbox';
  lb.innerHTML = '<button class="review-lightbox-close">&times;</button><img src="" alt="">';
  document.body.appendChild(lb);
  var img = lb.querySelector('img');
  var closeBtn = lb.querySelector('.review-lightbox-close');
  window.openReviewPhoto = function(el){
    var src = el.querySelector('img').src;
    img.src = src;
    lb.classList.add('open');
  };
  closeBtn.addEventListener('click', function(){ lb.classList.remove('open'); });
  lb.addEventListener('click', function(e){ if(e.target === lb) lb.classList.remove('open'); });
})();

/* MutationObserver for dynamic animated elements */
(function(){
  var sel = '.rv:not(.v),.rv-left:not(.v),.rv-right:not(.v),.rv-scale:not(.v),.rv-type:not(.v)';
  if(typeof MutationObserver !== 'undefined'){
    new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        m.addedNodes.forEach(function(n){
          if(n.nodeType === 1){
            if(n.matches && n.matches(sel)){
              new IntersectionObserver(function(e){if(e[0].isIntersecting)e[0].target.classList.add('v');},{threshold:.1}).observe(n);
            }
            n.querySelectorAll && n.querySelectorAll(sel).forEach(function(el){
              new IntersectionObserver(function(e){if(e[0].isIntersecting)e[0].target.classList.add('v');},{threshold:.1}).observe(el);
            });
          }
        });
      });
    }).observe(document.body, {childList:true, subtree:true});
  }
})();
